import api from '../api/userData-api';

export default {
    getStatisticData(params) {
        return new Promise((resolve, reject) => {
            api.getStatisticData(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getBannerStatisticData(params) {
        return new Promise((resolve, reject) => {
            api.getBannerStatisticData(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getMultiStatisticData(params) {
        return new Promise((resolve, reject) => {
            api.getMultiStatisticData(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getPPTStatisticData(params) {
        return new Promise((resolve, reject) => {
            api.getPPTStatisticData(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getAvgTime(params) {
        return new Promise((resolve, reject) => {
            api.getAvgTime(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getAvgProjectTime(params) {
        return new Promise((resolve, reject) => {
            api.getAvgProjectTime(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getRandomProcess(params) {
        return new Promise((resolve, reject) => {
            api.getRandomProcess(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getTableData(params) {
        return new Promise((resolve, reject) => {
            api.getTableData(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getCutoutStats(params) {
        return new Promise((resolve, reject) => {
            api.getCutoutStats(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getWorkStat(params) {
        return new Promise((resolve, reject) => {
            api.getWorkStat(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getCustomCategory(params) {
        return new Promise((resolve, reject) => {
            api.getCustomCategory(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    setCustomCategory(params) {
        return new Promise((resolve, reject) => {
            api.setCustomCategory(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    exportWorkStat(params) {
        return new Promise((resolve, reject) => {
            api.exportWorkStat(params).then((response) => {
                if (response.data && response.data.type === 'application/octet-stream') {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
        });
    },
    getTemplateGroupView(tplGroupId, reqTime, startTimeFrom, startTimeTo) {
        return new Promise((resolve, reject) => {
            api.getTemplateGroupView(tplGroupId, reqTime, startTimeFrom, startTimeTo).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateModuleView(templateId, reqTime, startTimeFrom, startTimeTo) {
        return new Promise((resolve, reject) => {
            api.getTemplateModuleView(templateId, reqTime, startTimeFrom, startTimeTo).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    }
}